module.exports = __webpack_public_path__ + "static/media/CircularPro-Book.c58d87e6.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/CircularPro-Book.ttf
// module id = 106
// module chunks = 0